import paths from '~/lib/paths';

export const PAGES = {
  ENRICHMENT: {
    CONFIGURATION: {
      TITLE: 'Enrichment',
      PATH: paths.dataEnrichmentIndex(),
    },
  },
  FORMS: {
    CONFIGURATION: {
      TITLE: 'Forms',
      PATH: paths.forms(),
    },
  },
  CONFIGURATIONS: {
    CONFIGURATION: {
      TITLE: 'Configurations',
      PATH: paths.configurations(),
    },
  },
} as const;
